import { render, staticRenderFns } from "./contentgroup.vue?vue&type=template&id=4ac35c76&scoped=true"
import script from "./contentgroup.vue?vue&type=script&lang=js"
export * from "./contentgroup.vue?vue&type=script&lang=js"
import style0 from "./contentgroup.vue?vue&type=style&index=0&id=4ac35c76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac35c76",
  null
  
)

export default component.exports